<div style="padding:30px">
    <div>
        <div style="text-align: right;margin:10px;font-size: 16px;">總金額:{{money|number}}</div>

        <app-table-v2 [type]="2"  [data]="data" [tcontent]="tcontent">
            <ng-template let-post #operation_dk>
                <div>
                    <a href="javascript:void(0)" title="提領紀錄"   (click)="choose(post.val.user_id);choose_data.name=post.val.name;choose_data.money=post.val.total_money;" data-toggle="modal" data-target=".bd-example-modal-xl">
                        <i style="margin: 0 10px 0 0;" class="fas fa-file-signature"></i>
                    </a>
                </div>
            </ng-template>
        </app-table-v2>
      
        <app-pagnation (callback)="callback($event)" [data]="pageobjstr"></app-pagnation> 
        <div *ngIf="data.length==0">無資料</div>
    </div>
</div>
<app-spinner [loading]="loading"></app-spinner>
<div *ngIf="edit_data" class="modal fade bd-example-modal-xl" tabindex="-1" role="dialog"  data-keyboard="false" data-backdrop="static"  aria-labelledby="myExtraLargeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <!-- Modal Header -->
            <div class="modal-header">
                <h3 class="modal-title">會員:{{choose_data.name}}</h3><br>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <h5>提領總額{{choose_data.money}}</h5>

                <table style="margin-top: 10px;" class="table table-responsive-sm" *ngIf="edit_data.length>0">
                    <thead>
                        <tr class="table-primary" style="font-size:18px;">
                            <th style="width:5%">日期</th>
                            <th style="width:15%"><i  style="margin-right:10px" class="fas fa-camera-retro"></i>比例</th>
                            <th style="width:15%"><i  style="margin-right:10px"class="fas fa-file-signature"></i>鑽石</th>       
                            <th style="width:15%"><i  style="margin-right:10px"class="fas fa-file-signature"></i>金額</th>       
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of edit_data; let i = index" class="{(index % 2 ==0)?'table-secondary':'table-light'}">
                            <td>{{item.create_dt}}</td>        
                            <td>{{item.rate}}</td>
                            <td>{{item.diamon}}</td>
                            <td>{{item.money}}</td>
                        </tr>
                    </tbody>
                </table>  
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button"   class="btn btn-primary" data-dismiss="modal">確認</button>
            </div>
        </div>
    </div>
</div>